module.exports = __webpack_public_path__ + "img/logo-abracol.5441487d.png";